import { MONITORING_ADD_TOOLTIP_PIN, MONITORING_REMOVE_TOOLTIP_PIN, MONITORING_SET_CURRENT_PERIOD, MONITORING_SET_TOOLTIP_DATA } from 'Redux/actionTypes';
// ------------------------------------
// Constants
// ------------------------------------
export const initialState = {
    tooltipData: { date: null, chartId: null, type: null },
    tooltipPins: []
};
// ------------------------------------
// Selectors
// ------------------------------------
/**
 * Simple function that takes Redux Store object and returns
 * subset of data that represents redux business-logic module slice
 * Beneficial because it encapsulates knowledge of
 * where to find that particular subset
 * @function
 * @param {Object} state redux Store object
 * @returns {Object} subset of data
 */
export const monitoringTooltipModuleSelector = (state) => state.monitoringTooltipModule;
export const monitoringTooltipDataSelector = (state) => monitoringTooltipModuleSelector(state).tooltipData;
export const monitoringTooltipPinsSelector = (state) => monitoringTooltipModuleSelector(state).tooltipPins;
// ------------------------------------
// Reducer
// ------------------------------------
// eslint-disable-next-line
const monitoringTooltipReducer = (state = initialState, action) => {
    switch (action.type) {
        case MONITORING_SET_TOOLTIP_DATA:
            return {
                ...state,
                tooltipData: action.payload
            };
        case MONITORING_ADD_TOOLTIP_PIN: {
            const date = action.payload;
            const { tooltipPins } = state;
            if (tooltipPins.length < 3) {
                return {
                    ...state,
                    tooltipPins: [...state.tooltipPins, date]
                };
            }
            return {
                ...state,
                tooltipPins: [tooltipPins[1], tooltipPins[2], date]
            };
        }
        case MONITORING_REMOVE_TOOLTIP_PIN:
            return {
                ...state,
                tooltipPins: state.tooltipPins.filter((pinDate) => pinDate !== action.payload)
            };
        case MONITORING_SET_CURRENT_PERIOD:
            return initialState;
        default:
            return state;
    }
};
export default monitoringTooltipReducer;
